import { render } from "./CZAccrualsGas.vue?vue&type=template&id=590ce889&scoped=true&ts=true"
import script from "./CZAccrualsGas.vue?vue&type=script&lang=ts"
export * from "./CZAccrualsGas.vue?vue&type=script&lang=ts"

import "./CZAccrualsGas.vue?vue&type=style&index=0&id=590ce889&scoped=true&lang=css"

import exportComponent from "C:\\Develop\\Czone_UI_EIC\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-590ce889"]])

export default __exports__